<template>
  <div class="container-md">
    <div class="row justify-content-center body">
      <div class="col-auto px-5">
        <div class="py-3 text-center">
          <h3>{{ $t("signUpResult.title") }}</h3>
        </div>
        <form class="border bg-light p-3">
          <div class="text-center">
            <p v-html="$t('signUpResult.message')" class="text-body"></p>
          </div>
          <div class="d-grid gap-2 p-2">
            <button type="button" class="btn btn-primary" @click="login()">{{ $t("signUpResult.submit") }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    login() {
      this.$router.push({name: "login"})
    },
  },
}
</script>

<style scoped>
.body {
  height: 100%;
  padding-top:128px;
}
</style>
